export default __webpack_public_path__ + "static/Release_Form-e3a2cc033bbfdcc440384777c76f5ec2.pdf";